<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAdmin } from 'dashboard/composables/useAdmin';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

// Aceleres: controle admin-only do aviso global de instabilidade Meta/WhatsApp.
const store = useStore();
const { currentAccount } = useAccount();
const { isAdmin } = useAdmin();

const currentUser = computed(() => store.getters['auth/getCurrentUser']);

const DEFAULT_MESSAGE =
  'Estamos enfrentando instabilidade nos serviços da Meta. O envio e recebimento de mensagens pode sofrer atrasos temporários.';

const enabled = ref(false);
const message = ref('');
const saving = ref(false);
const savedMsg = ref('');
const errorMsg = ref('');

const endpoint = () =>
  `/api/v1/accounts/${currentAccount.value?.id}/aceleres/meta_notice`;
const headers = () => ({
  api_access_token: currentUser.value?.access_token || '',
});

async function carregar() {
  try {
    const { data } = await axios.get(endpoint(), { headers: headers() });
    enabled.value = !!data.enabled;
    message.value = data.message || DEFAULT_MESSAGE;
  } catch {
    message.value = DEFAULT_MESSAGE;
  }
}

async function salvar() {
  saving.value = true;
  savedMsg.value = '';
  errorMsg.value = '';
  try {
    const { data } = await axios.post(
      endpoint(),
      {
        enabled: enabled.value,
        message: (message.value || '').trim() || DEFAULT_MESSAGE,
      },
      { headers: headers() }
    );
    enabled.value = !!data.enabled;
    message.value = data.message || DEFAULT_MESSAGE;
    savedMsg.value = 'Salvo!';
    setTimeout(() => {
      savedMsg.value = '';
    }, 3000);
  } catch {
    errorMsg.value =
      'Erro ao salvar. Verifique se você tem permissão de administrador.';
  } finally {
    saving.value = false;
  }
}

onMounted(() => {
  if (isAdmin.value) carregar();
});
</script>

<template>
  <SectionLayout
    v-if="isAdmin"
    title="Aviso de instabilidade (Meta/WhatsApp)"
    description="Quando ligado, exibe um aviso no topo do painel para TODOS os atendentes de TODAS as empresas, avisando que o envio/recebimento de mensagens pode sofrer atrasos por instabilidade da Meta."
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="enabled" @change="salvar" />
      </div>
    </template>
    <div class="flex flex-col gap-3 mt-2">
      <label class="text-sm font-medium text-n-slate-12">Mensagem exibida</label>
      <textarea
        v-model="message"
        rows="3"
        class="w-full text-sm rounded-md border border-n-weak bg-n-background p-2 text-n-slate-12"
        placeholder="Mensagem do aviso..."
      />
      <div class="flex items-center gap-3 mt-1">
        <button
          type="button"
          :disabled="saving"
          class="rounded-md bg-woot-500 px-4 py-2 text-sm font-medium text-white hover:bg-woot-600 disabled:opacity-50 cursor-pointer"
          @click="salvar"
        >
          {{ saving ? 'Salvando...' : 'Salvar' }}
        </button>
        <span v-if="enabled" class="text-xs text-amber-600 font-medium"
          >● Aviso ATIVO</span
        >
        <span v-if="savedMsg" class="text-sm text-green-600 font-medium">{{
          savedMsg
        }}</span>
        <span v-if="errorMsg" class="text-xs text-red-600">{{ errorMsg }}</span>
      </div>
    </div>
  </SectionLayout>
</template>
